import { Column, Grid, Label, Link, Row, useAlignments, useScreen } from 'metrix-common3';

const DemoPolicyWeb = ({ policy, context }) => {
    const alignments = useAlignments();
    const screen = useScreen();
    const mobile = screen?.isMobile;
    const tablet = screen?.isTablet;
    const desktop = screen?.isDesktop;

    const {
        policyDescription,
        insuredName,
        brokerCompanyName,
        assignedTo,
        submissionReferenceNumber,
        policyNumber,
        doingBusinessAs,
        productDescription,
        createdOnDate,
        transactionStatus,
        transactionType,
        policyTransactionGuid,
        quoteNumber,
        quoteColorTag,
    } = policy;

    const profileLink = `${context.configuration.policyWeb}/profile?entity=${policyTransactionGuid}`;

    let description = policyDescription || '';
    if (insuredName) {
        description = `${insuredName} - ${description}`;
    }

    return (
        <Grid>
            <Row>
                {!mobile && (
                    <Column md={tablet ? 2 : 0.5}>
                        <Link text={submissionReferenceNumber} textAlign={alignments.left} href={profileLink} />
                    </Column>
                )}
                {desktop && (
                    <Column md={1}>
                        <Label text={policyNumber} textAlign={alignments.left} />
                    </Column>
                )}
                {desktop && (
                    <Column md={1}>
                        <Label text={quoteNumber} textAlign={alignments.left} />
                    </Column>
                )}
                {mobile && (
                    <Column xs={4}>
                        <Label text={description} textAlign={alignments.left} />
                        <Link text={submissionReferenceNumber} href={profileLink} textAlign={alignments.left} />
                    </Column>
                )}
                {!mobile && (
                    <Column md={tablet ? 2 : 1}>
                        <Label text={insuredName} textAlign={alignments.left} />
                    </Column>
                )}
                {!mobile && (
                    <Column md={2}>
                        <Label text={doingBusinessAs} textAlign={alignments.left} />
                    </Column>
                )}
                {!mobile && (
                    <Column md={tablet ? 2 : 1}>
                        <Label text={productDescription} textAlign={alignments.left} />
                    </Column>
                )}
                {!mobile && (
                    <Column md={1}>
                        <Label text={createdOnDate} textAlign={alignments.left} />
                    </Column>
                )}
                <Column xs={4} md={tablet ? 2 : 1}>
                    <Label text={transactionStatus} textAlign={alignments.left} />
                </Column>
                {desktop && (
                    <Column md={1}>
                        <Label text={brokerCompanyName || ''} textAlign={alignments.left} />
                    </Column>
                )}
                {desktop && (
                    <Column md={1}>
                        <Label text={assignedTo || ''} textAlign={alignments.left} />
                    </Column>
                )}
                {desktop && (
                    <Column md={0.5}>
                        <Label text={quoteColorTag} textAlign={alignments.left} />
                    </Column>
                )}
                <Column xs={4} md={1}>
                    <Label text={transactionType} textAlign={alignments.left} />
                </Column>
            </Row>
        </Grid>
    );
};

export default DemoPolicyWeb;
